import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const NotificationFilledIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "notification-filled",
  "NotificationFilledIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M5.69046 12.6666C5.8522 13.7974 6.82467 14.6666 8.00016 14.6666C9.17565 14.6666 10.1481 13.7974 10.3099 12.6666H13.6668V11.3333L12.4119 9.53443V6.41172C12.4119 4.20179 10.787 2.37137 8.66683 2.05V0.666626H7.3335V2.05C5.21328 2.37137 3.5884 4.20179 3.5884 6.41172V9.53443L2.3335 11.3333V12.6666H5.69046Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default NotificationFilledIcon;
